import { useQuery } from '@tanstack/react-query';
import { getAgencyEntryMethodPreference } from '../service';

function useAgencyEntryMethodPreference() {
    const query = useQuery({
        queryKey: ['agency', 'entry-method-preferences'],
        queryFn: () => getAgencyEntryMethodPreference(),
    });

    return query;
}

export { useAgencyEntryMethodPreference };
